import { StyleCreator$1_$ctor, StyleImports_makeStyles_get } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Styles.fs.js";
import { StyleCreator$1__create_4EAC9E1E } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Styles.fs.js";
import { cons, empty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, anonRecord_type, string_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { uncurry2, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Button, TextField, Typography } from "@mui/material";
import { password as password_2 } from "./Shared/Validate.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { GenericResponse_$reflection } from "./Shared/ApiDataTypes.js";
import { unwrap, map, defaultArg, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { loadingIndicatorSmall, tryFocus, SnackError } from "./ViewHelpers.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";

const useStyles = StyleImports_makeStyles_get((() => {
    let f1;
    const styles = StyleCreator$1_$ctor();
    f1 = ((_arg) => {
        const submit = StyleCreator$1__create_4EAC9E1E(styles, ofArray([["color", "#FFFFFF"], ["borderColor", "hsl(207.3, 30.8%, 21%)"], ["backgroundColor", "hsl(207.3, 30.8%, 21%)"], ["marginTop", 10], ["height", 37]]));
        return {
            inpt: StyleCreator$1__create_4EAC9E1E(styles, ofArray([["marginTop", 10], ["marginBottom", 10]])),
            submit: submit,
        };
    });
    return (arg) => {
        const o = f1(arg);
        return Object.assign({}, o);
    };
})());

class RecoveryState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ValidatingToken", "Submit", "Expired", "Updated"];
    }
}

function RecoveryState_$reflection() {
    return union_type("PasswordRecovery.RecoveryState", [], RecoveryState, () => [[], [], [], []]);
}

export function invalidRecovery() {
    let elems_2, elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "login-holder"], ["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 100 + "vh",
        backgroundColor: "#f1f1f1",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: 20,
        margin: 10,
        maxWidth: 350,
        backgroundColor: "#FFFFFF",
        borderRadius: 4,
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        textAlign: "center",
    }], (elems = [createElement("img", {
        src: "/logo.png",
        style: {
            width: 100 + "%",
            marginBottom: 15 + "px",
            maxWidth: 200,
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Typography, [["variant", "h6"], ["style", {
        textAlign: "center",
    }], ["children", "Tilbakestillingslenken er utløpt eller ugyldig."]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function Recover(recoverInputProps) {
    let elems_4, elems_3;
    const token = recoverInputProps.token;
    const s = useStyles();
    const patternInput = reactApi.useState("");
    const password = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const patternInput_2 = reactApi.useState(true);
    const setValidPassword = patternInput_2[1];
    const patternInput_3 = reactApi.useState(true);
    const setMatching = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setProcessing = patternInput_4[1];
    const processing = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setErrMsg = patternInput_5[1];
    const patternInput_6 = reactApi.useState(new RecoveryState(0, []));
    const setCurrentState = patternInput_6[1];
    const tryCommit = () => {
        if (!password_2(password)) {
            setValidPassword(false);
        }
        else {
            setValidPassword(true);
            if (password !== patternInput_1[0]) {
                setMatching(false);
            }
            else {
                setMatching(true);
                setProcessing(true);
                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let item, body, decoder, data_1, caseStrategy_3, extra_3;
                    return ((item = {
                        Password: password,
                    }, (body = Auto_generateBoxedEncoder_437914C6(anonRecord_type(["Password", string_type]), undefined, undefined, undefined)(item), (decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${"/api/password-recovery/recover"}?token=${token}`, properties_3).then((_arg) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                    let matchValue;
                                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })()))))))).then((_arg_2) => {
                        const res = _arg_2;
                        if (res.tag === 0) {
                            const x_1 = res.fields[0];
                            if (x_1.Result === "success") {
                                setCurrentState(new RecoveryState(3, []));
                                setProcessing(false);
                                return Promise.resolve();
                            }
                            else {
                                setErrMsg(x_1.Message);
                                setProcessing(false);
                                return Promise.resolve();
                            }
                        }
                        else {
                            setErrMsg("Kunne ikke oppdatere passord. Vennligst prøv igjen senere.");
                            setProcessing(false);
                            return Promise.resolve();
                        }
                    });
                }));
                pr_1.then();
            }
        }
    };
    reactApi.useEffect(() => {
        let properties_6;
        let pr_5;
        let pr_4;
        let pr_3;
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
        const data_5 = undefined;
        const caseStrategy_11 = undefined;
        const extra_11 = extraCoders;
        try {
            const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${"/api/password-recovery/validate"}?token=${token}`, properties_3_1).then((_arg_3) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_3 = (pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_3 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_4 = (pr_3.then((result_2) => Result_MapError(testRedirect, result_2)));
        pr_5 = (pr_4.then((res_1) => {
            let matchResult, y_1, y_2;
            if (res_1.tag === 1) {
                if (res_1.fields[0].tag === 2) {
                    if ((res_1.fields[0].fields[0].status) === 410) {
                        matchResult = 1;
                        y_2 = res_1.fields[0].fields[0];
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 0;
                y_1 = res_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    if (y_1.Result === "success") {
                        setCurrentState(new RecoveryState(1, []));
                    }
                    else {
                        setErrMsg(y_1.Message);
                    }
                    break;
                }
                case 1: {
                    setCurrentState(new RecoveryState(2, []));
                    break;
                }
                case 2: {
                    setErrMsg("Kunne ikke validere tilbakestillingslenke. Vennligst prøv igjen senere.");
                    break;
                }
            }
        }));
        pr_5.then();
    }, []);
    return createElement("div", createObj(ofArray([["className", "login-holder"], ["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 100 + "vh",
        backgroundColor: "#f1f1f1",
    }], (elems_4 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_5[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: 20,
        margin: 10,
        maxWidth: 350,
        backgroundColor: "#FFFFFF",
        borderRadius: 4,
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
    }], (elems_3 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            textAlign: "center",
        }], (elems = [createElement("img", {
            src: "/logo.png",
            style: {
                width: 100 + "%",
                maxWidth: 200,
                marginBottom: 15 + "px",
                backgroundColor: "hsl(207.3, 30.8%, 21%)",
                padding: ((10 + "px ") + 30) + "px",
                borderRadius: 5,
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            const matchValue_2 = patternInput_6[0];
            return (matchValue_2.tag === 3) ? append(singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["style", {
                textAlign: "center",
            }], ["children", "Passord oppdatert."]])), delay(() => singleton(createElement("a", {
                style: {
                    marginTop: 10,
                    textAlign: "center",
                },
                href: "/",
                children: "Logg inn",
            })))) : ((matchValue_2.tag === 2) ? singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["style", {
                textAlign: "center",
            }], ["children", "Tilbakestillingslenken er utløpt eller ugyldig."]])) : ((matchValue_2.tag === 1) ? append(singleton(createElement("span", {
                style: {
                    textAlign: "center",
                },
                children: "Tilbakestill passord.",
            })), delay(() => {
                let children, elements;
                return singleton((children = ofArray([MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["className", s.inpt]), delay(() => append(singleton(["id", "input-pwd"]), delay(() => append(singleton(["autoFocus", true]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Nytt passord"]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["type", "password"]), delay(() => append(singleton(["onChange", (e) => {
                    patternInput[1](e.target.value);
                }]), delay(() => append(!patternInput_2[0] ? append(singleton(["error", true]), delay(() => singleton(["helperText", "Passord må være minst åtte tegn"]))) : empty_1(), delay(() => singleton(["onKeyUp", (kc) => {
                    kc.preventDefault();
                    if ((kc.key === "Enter") && !processing) {
                        if (!password_2(password)) {
                            setValidPassword(false);
                        }
                        else {
                            setValidPassword(true);
                            tryFocus("repeat-pwd");
                        }
                    }
                }])))))))))))))))))))))))))), MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["className", s.inpt]), delay(() => append(singleton(["id", "repeat-pwd"]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Gjenta passord"]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["type", "password"]), delay(() => append(singleton(["onChange", (e_1) => {
                    patternInput_1[1](e_1.target.value);
                }]), delay(() => append(!patternInput_3[0] ? append(singleton(["error", true]), delay(() => singleton(["helperText", "Passord er ikke like"]))) : empty_1(), delay(() => singleton(["onKeyUp", (kc_1) => {
                    kc_1.preventDefault();
                    if ((kc_1.key === "Enter") && !processing) {
                        tryCommit();
                    }
                }])))))))))))))))))))))))), MuiHelpers_createElement(Button, [["className", s.submit], ["type", "submit"], ["fullWidth", true], ["variant", "contained"], ["onClick", (e_2) => {
                    e_2.preventDefault();
                    if (!processing) {
                        tryCommit();
                    }
                }], (elements = toList(delay(() => (!processing ? singleton("Oppdater passord") : singleton(loadingIndicatorSmall())))), ["children", reactApi.Children.toArray(Array.from(elements))])])]), createElement("form", {
                    children: reactApi.Children.toArray(Array.from(children)),
                })));
            })) : singleton(createElement("div", createObj(ofArray([["style", {
                textAlign: "center",
            }], (elems_1 = [loadingIndicatorSmall()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

